<template>
  <v-flex md12>
    <div class="wrap-chart" :class="chartName"></div>
  </v-flex>
</template>
<script>
import { translate } from "../common/HelperFunctions";

export default {
  props: {
    chartData: {
      type: Array,
      default: () => []
    },
    chartName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      chartDataToPlot: []
    };
  },
  mounted: function() {
    if (this.chartData.length) {
      this.chartData[0].label = "lng_heat_production";
      this.chartData[1].label = "lng_hot_water_production";
      this.getChartDataToPlot();
      this.plotChart();
    }
  },
  methods: {
    plotChart() {
      $.plot(
        $(this.$el.getElementsByClassName(this.chartName)),
        this.chartDataToPlot,
        this.setChartOptions()
      );
    },
    getChartDataToPlot() {
      this.chartDataToPlot = [
        {
          label: translate(this.chartData[0].label),
          data: this.chartData[0].data,
          color: this.chartData[0].color,
          bars: { barWidth: this.chartData[0].bars.barWidth * 0.8 }
        },
        {
          label: translate(this.chartData[1].label),
          data: this.chartData[1].data,
          color: this.chartData[1].color,
          bars: { barWidth: this.chartData[1].bars.barWidth * 0.8 }
        }
      ];
    },
    setChartOptions() {
      let that = this;
      return {
        series: { stack: null },
        lines: {
          show: false,
          fill: true,
          steps: false
        },
        bars: {
          show: true,
          align: "center"
        },
        xaxis: {
          mode: "time",
          monthNames: [
            "january",
            "february",
            "march",
            "april",
            "may",
            "june",
            "july",
            "august",
            "september",
            "october",
            "november",
            "december"
          ],
          tickFormatter: function(tickValue, index) {
            let date = new Date(+tickValue);
            let tick = date.getHours() + ":00";
            if (that.chartName === "hours=24") return tick;
            else if (that.chartName === "days=24") return date.getUTCDate();
            else if (that.chartName === "months=12")
              return index.options.monthNames[date.getMonth()];
            else if (that.chartName === "years=12") return date.getFullYear();
          }
        },
        yaxis: {
          tickFormatter: function(tickValue) {
            if (tickValue < 50) {
              return Number(tickValue).toFixed(1) + translate("lng_kg");
            } else {
              return Number(tickValue).toFixed() + translate("lng_kg");
            }
          }
        },
        legend: {
          noColumns: 0,
          labelBoxBorderColor: "#000000",
          position: "nw"
        },
        grid: {
          hoverable: true,
          borderWidth: 2,
          backgroundColor: { colors: ["#999", "#ffffff"] }
        },
        tooltip: true,
        tooltipOpts: {
          defaultTheme: false,
          content: function(label, x, y) {
            let tooltip = `<div class="tooltip-content graph-bg"><h4>${label}</h4><ul>
                <li>${that.chooseToolTipDate(x)}</li>
                <li>${Number(y).toFixed(1)}</li></ul></div>`;
            return tooltip;
          }
        }
      };
    },
    chooseToolTipDate(selectedValue) {
      let date = new Date(+selectedValue);
      if (this.chartName === "hours=24")
        return date.toLocaleDateString("en-US", {
          hour: "numeric",
          minute: "numeric"
        });
      else if (this.chartName === "days=24") {
        let date = new Date(selectedValue).toISOString();
        return date.split("T")[0];
      } else if (this.chartName === "months=12")
        return date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long"
        });
      else if (this.chartName === "years=12")
        return date.toLocaleDateString("en-US", { year: "numeric" });
    }
  }
};
</script>
